













































































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import GExamListActionIcons from '@/views/GExamList/GExamListActionIcons.vue';
import GOptionalData from '@/components/GOptionalData.vue';
import { EvalSettingSimple } from '@/models/evalSetting/eval-setting-simple';
import { masterModule } from '@/store/modules/entities/master.module';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module.ts';
import { QuestionType } from '@/models/evalSetting/question-type';
import GExamListTitleInput from '@/views/GExamList/GExamListTitleInput.vue';
import GExamListStartTimeInput from '@/views/GExamList/GExamListStartTimeInput.vue';
import GExamListDeadlineInput from '@/views/GExamList/GExamListDeadlineInput.vue';
import { GPageBase } from '@/mixins';
import { CompetencyType } from '@/constants/competencyType.enum';
import { GEnum } from '@/constants/enum.defination';

@Component({
  name: 'GExamListTable',
  components: { GExamListStartTimeInput, GExamListDeadlineInput, GExamListTitleInput, GOptionalData, GExamListActionIcons },
  computed: {},
  methods: {},
})
export default class GExamListTable extends Mixins(GPageBase) {
  columns: any[] = []; // テーブル形式のテーブルカラム情報
  selectedItem: number;
  reportTypes: GEnum.PersonalReportDisplayType[] = evalSettingModule.reportSelectItems;

  @Prop() evalSettingSimples: EvalSettingSimple[];
  mounted() {
    this.columns = [
      {
        title: this.$t('PROGRESS').toString(),
        width: 40,
        align: 'center',
        slot: 'detail-link',
      },
      {
        title: this.$t('EVAL_COURSE_NAME').toString(),
        width: this.isRoleNormal ? 230 : 160,
        align: 'center',
        slot: 'title',
      },
      {
        title: this.$t('START_DATE').toString(),
        key: 'startTime',
        align: 'center',
        width: 145,
        slot: 'startTime',
      },
      {
        title: this.$t('END_DATE').toString(),
        key: 'deadline',
        align: 'center',
        width: 145,
        slot: 'deadline',
      },
      {
        title: this.$t('EVAL_COURSE_STATUS').toString(),
        key: 'status',
        align: 'center',
        width: 100,
        slot: 'status',
      },
      {
        title: this.$t('SCORE').toString(),
        key: 'score',
        align: 'center',
        width: 45,
        slot: 'score',
      },
      {
        title: this.$t('REPORT_LINK').toString(),
        slot: 'reportLinks',
        width: 115,
        align: 'center',
      },
      {
        title: this.$t('REPORT_STATUS').toString(),
        slot: 'reportStatus',
        width: 130,
        align: 'center',
      },
      {
        title: this.$t('QUESTION_TYPE').toString(),
        align: 'center',
        width: 130,
        slot: 'questionSettingType',
      },
      {
        title: ' ',

        slot: 'action',
        align: 'right',
      },
    ];
  }

  get isRoleNormal(): boolean {
    return this.$store.state.account.isRoleNormal;
  }

  // 表示文字列を取得
  competencyTypeReport(reportType: GEnum.PersonalReportDisplayType): string {
    return CompetencyType.personalReportType(reportType);
  }

  questionSettingTypeTitle(questionSettingType: number): string {
    if (!masterModule.questionType(questionSettingType)) {
      return '';
    }
    return masterModule.questionType(questionSettingType).title;
  }

  questionType(questionSettingType: number): QuestionType {
    return masterModule.questionType(questionSettingType);
  }

  handleToEvalSettingDetail(evalSettingID: number) {
    this.$emit('handleToEvalSettingDetail', evalSettingID);
  }

  handleUpdateTitle(evalSettingSimple: EvalSettingSimple, beforeTitle: string) {
    this.$emit('handleUpdateTitle', evalSettingSimple, beforeTitle);
  }

  handleUpdateStartTime(evalSettingSimple: EvalSettingSimple, beforeStartTime: Date) {
    this.$emit('handleUpdateStartTime', evalSettingSimple, beforeStartTime);
  }

  handleUpdateDeadline(evalSettingSimple: EvalSettingSimple, beforeDeadline: Date) {
    this.$emit('handleUpdateDeadline', evalSettingSimple, beforeDeadline);
  }

  handleUpdateReportLink(evalSettingSimple: EvalSettingSimple) {
    this.$emit('updateReportLink', evalSettingSimple);
  }

  rowDeadline (row: EvalSettingSimple) {
      if (row.status === GEnum.ExamStatus.EndOfExamination) {
        return 'deadline-row';
      }
      return '';
  }
  requireGiftRequestCourseAndReportStatus (row: EvalSettingSimple): boolean {
    if (row.giftRequired && row.reportZipStatus === GEnum.ReportStatus.NoRequest) {
      return true;
    }
    return false;
  }
}
